import * as React from 'react';

import type { IconProps } from '../types';

const StatusToDo = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 16, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        {/* 3/8 pie wedge (12 o'clock → 135°). The round-join stroke in the same
            colour outsets the r=6.4 sector to the r≈6.9 outer radius and
            ~0.5 corner rounding shared by the other status pies. */}
        <path
          fill="hsl(var(--twc-status-icon-to-do))"
          stroke="hsl(var(--twc-status-icon-to-do))"
          strokeWidth={1}
          strokeLinejoin="round"
          d="M8 8 L8 1.6 A6.4 6.4 0 0 1 12.5255 12.5255 Z"
        />
      </svg>
    );
  }
);

StatusToDo.displayName = 'StatusToDo';

export { StatusToDo };
